import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../../services/Api';
import { npsModalActionTypes } from './Constants';
import * as npsModalActions from './Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';

export default function* () {
	yield all([yield takeLatest(npsModalActionTypes.SUBMIT_NPS_MODAL, handleSubmitNPSRequest)]);
}

export function* handleSubmitNPSRequest({ payload }) {
	try {
		const { data: requestData, requestId } = payload || {};
		const { score, message, closed } = requestData || {};

		yield call(processRequest, `nps_feedbacks/${requestId}`, 'PUT', {
			...requestData,
		});

		if (typeof score === 'number') {
			yield put(npsModalActions.submitNPSModalSuccess({ scoreSubmitSuccess: true }));
		}
		if (message) {
			yield put(npsModalActions.submitNPSModalSuccess({ fullSuccess: true }));
		}
		if (closed) {
			yield put(npsModalActions.submitNPSModalSuccess({ open: false }));
		}
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(npsModalActions.submitNPSModalError());
	}
}
